import { FC } from 'react';
import { UserAvatar, UserAvatarProps } from './user-avatar.component';
import { Box, Typography } from '@mui/material';
import { Colors } from '../../constants';

export const UserName: FC<UserAvatarProps> = props => {
	const { ...avatarProps } = props;

	return (
		<Box
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '16px',
			}}
		>
			<UserAvatar {...avatarProps} />

			<Typography
				sx={{
					display: { xs: 'none', sm: 'block' },
					fontFamily: 'Integral CF, sans-serif',
					fontSize: '16px',
					fontWeight: '500',
					lineHeight: '20px',
					color: Colors.white,
					userSelect: 'none',
				}}
			>
				{avatarProps?.fullName}
			</Typography>
		</Box>
	);
};
